import script from "./TournamentsIndexView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TournamentsIndexView.vue?vue&type=script&lang=ts&setup=true"

import "./TournamentsIndexView.vue?vue&type=style&index=0&id=0dca3e64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dca3e64"]])

export default __exports__